/**
 * How long any Suspense boundary in the app may show its fallback before it becomes an error.
 *
 * A promise that never settles produces no rejection and no event, so a boundary suspended on one
 * used to show its skeleton forever: only rejections were bounded (by the error boundary), and the
 * suspended state had no exit at all. 30s matches the query client's per-attempt backstop
 * (`QUERY_DEADLINE_MS`), and this timer starts when the fallback COMMITS — after the query that
 * suspended it started — so a slow query surfaces its own, more specific error first. This bound
 * catches everything else that can suspend: a lazy module that never loads, a `use()`d promise
 * nobody settles, a query that bypassed the bounded client.
 */
export const SUSPENSE_DEADLINE_MS = 30_000;
